import MenuSlider from "./MenuSlider";

const pages = [
  "/softmenu/page-1.jpg",
  "/softmenu/page-2.jpg",
  "/softmenu/page-3.jpg",
  "/softmenu/page-4.jpg",
  "/softmenu/page-5.jpg",
  "/softmenu/page-6.jpg",
  "/softmenu/page-7.jpg",
  "/softmenu/page-8.jpg",
  "/softmenu/page-9.jpg",
  "/softmenu/page-10.jpg",
  "/softmenu/page-11.jpg",
  "/softmenu/page-12.jpg",
  "/softmenu/page-13.jpg",
  "/softmenu/page-14.jpg",
  "/softmenu/page-15.jpg",
  "/softmenu/page-16.jpg",
  "/softmenu/page-17.jpg",
  "/softmenu/page-18.jpg",
];

const MainMenu = () => {
  const handleReservation = () => {
    window.open(
      "https://resy.com/cities/edison-nj/venues/house-of-bombay",
      "_blank"
    );
  };

  return (
    <section className="menu-section" id="mainmenu">
      <div className="hero-border-menu">
        <div className="menu-container">
          <div className="inner-menu-container">
            <h2 className="menu-title">The Main Menu</h2>

            <p className="menu-text">This menu is a map of Bombay.</p>

            <p className="menu-text">
              A city where street food is as revered as celebration meals, and
              everyday comfort often carries the deepest stories. What you’ll
              find here are dishes born in lanes, cafés, homes, and
              neighbourhood rituals, reinterpreted with care, technique, and
              balance. Some plates may feel familiar. Others may be new. But
              each one reflects how Bombay eats: generously, boldly, and
              together. For those who know the city, it’s recognition.
            </p>

            <p className="menu-text">
              For those discovering it, this is where the journey begins.
            </p>

            <p className="par-menu-btn">
              <button className="menu-btn" onClick={handleReservation}>
                BOOK A TABLE
              </button>
            </p>
          </div>

          <div className="carousel">
            <MenuSlider pages={pages} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainMenu;
